import { useMutation } from "@apollo/client/react";
import { UPDATE_INVOICE_UPLOAD_DOCUMENT_SERVICE_DETAILS } from "../../mutations/documentHandler/updateInvoiceDocumentUploadDocumentServiceDetails";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";

export const useUpdateInvoiceDocumentUploadDocumentServiceDetails = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: () => void;
}) => {
  const [updateServiceDetails, { data, loading, error }] = useMutation(
    UPDATE_INVOICE_UPLOAD_DOCUMENT_SERVICE_DETAILS,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS, GET_CLIENTS_WITH_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    },
  );

  return { updateServiceDetails, data, loading, error };
};
